// extracted by mini-css-extract-plugin
export default {"separator":"kZC2La"};